import { useSeo } from "@/lib/seo";
import { PageHeader, Section } from "@/components/blocks";
import { Placeholder } from "@/components/Placeholder";

const Block = ({ title, children }) => (
  <div className="border-b border-[#0B0A08]/10 py-8 last:border-b-0">
    <h2 className="font-serif text-xl tracking-tight">{title}</h2>
    <div className="prose-editorial mt-3 space-y-3 text-sm">{children}</div>
  </div>
);

export default function Privacy() {
  useSeo({
    title: "Privacy Policy — Nanny Poppins UAE",
    description:
      "How Nanny Poppins collects, uses and protects the information you share through our forms.",
  });

  return (
    <div>
      <PageHeader eyebrow="Privacy Policy" title="Your privacy, respected." />
      <Section className="max-w-3xl">
        <p className="text-sm text-[#0B0A08]/55">
          Last updated: <Placeholder>To be confirmed</Placeholder>
        </p>

        <Block title="Who we are">
          <p>
            This website is operated by <Placeholder>Legal entity name — to be confirmed</Placeholder>{" "}
            ("Nanny Poppins", "we", "us"). This policy explains how we handle information you share with us.
          </p>
        </Block>

        <Block title="Information we collect">
          <p>
            We collect the details you voluntarily provide through our forms — such as your name, contact
            details, the care you're looking for, and (for nannies) your experience and any documents you
            choose to upload.
          </p>
          <p>
            We deliberately do not ask for children's full names or dates of birth, medical records,
            passports, Emirates IDs, visa details or bank information through these public forms. Please do not
            submit them.
          </p>
        </Block>

        <Block title="How we use it">
          <p>
            We use your information solely to review your request or application, to match families with
            nannies, and to contact you about your submission using your preferred method.
          </p>
        </Block>

        <Block title="How we store and protect it">
          <p>
            Submissions are stored securely in our database and are kept private to our team. Nanny documents
            are held in private storage — they are never given public links or indexed by search engines.
          </p>
        </Block>

        <Block title="Sharing">
          <p>
            We do not sell your information. Details are only shared as needed to facilitate a potential match,
            and never published in a public directory.
          </p>
        </Block>

        <Block title="Your choices">
          <p>
            You may ask us to access or delete the information you've submitted. Contact details will be
            published here once available: <Placeholder>Privacy contact — coming soon</Placeholder>.
          </p>
        </Block>
      </Section>
    </div>
  );
}
